import styled from 'styled-components';

import { colors, radius } from '../../../../styles/tokens';

export const Content = styled.div`
  min-height: 100%;

  padding: 40px;

  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: 1199px) {
    padding: 20px;
  }
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 8px;
`;

export const PageTitle = styled.h1`
  font-size: 36px;
  font-weight: 800;
  color: ${colors.onSurface};
  letter-spacing: -0.01em;
  margin-bottom: 4px;
`;

export const PageSubtitle = styled.p`
  font-size: 14px;
  color: ${colors.onSurfaceVariant};
`;

export const PeriodToggle = styled.div`
  display: flex;
  gap: 8px;
`;

interface PeriodButtonProps {
  active: boolean;
}

export const PeriodButton = styled.button<PeriodButtonProps>`
  padding: 8px 24px;
  border: none;
  border-radius: ${radius.full};

  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;

  background-color: ${({ active }) =>
    active ? colors.primary : colors.surfaceContainer};
  color: ${({ active }) => (active ? colors.onPrimary : colors.onSurface)};

  &:hover {
    background-color: ${({ active }) =>
      active ? colors.primary : colors.surfaceContainerHigh};
  }
`;

export const StatsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
`;

export const BillingStatsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
`;

export const MainGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
  gap: 24px;

  @media (max-width: 1199px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const Sidebar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
